import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from '@/config/environment';
import type { RootState } from '../index';

const baseQuery = fetchBaseQuery({
  baseUrl: `${getApiBaseUrl()}/api/v1`,
  prepareHeaders: (headers, { getState }) => {
    // Get token from auth state
    const token = (getState() as RootState).auth.token;
    
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    
    headers.set('content-type', 'application/json');
    
    return headers;
  },
});

// Base query with error handling
const baseQueryWithErrorHandling = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);
  
  if (result.error) {
    // Handle 401 errors (unauthorized)
    if (result.error.status === 401) {
      // Dispatch logout action
      api.dispatch({ type: 'auth/logout' });
    }
    
    // Handle other errors
    console.error('API Error:', result.error);
  }
  
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: [
    'User',
    'Booking',
    'Vehicle',
    'Driver',
    'Location',
    'Dashboard',
    'Analytics',
    'Verification',
    'Dispute',
  ],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {} = apiSlice;